// extracted by mini-css-extract-plugin
var _1 = "Modal-module__actionFooter--AkMWs";
var _2 = "Modal-module__alignEnd--pFoSC";
var _3 = "Modal-module__animatedBackground--CSkRu";
var _4 = "Modal-module__closeContainer--BOZc4";
var _5 = "Modal-module__fullscreen--z2Iq9";
var _6 = "Modal-module__modal--w_6PR";
var _7 = "Modal-module__noPadding--f25fx";
var _8 = "Modal-module__primary--FQIld";
var _9 = "Modal-module__small--DzWcx";
var _a = "Modal-module__subtitle--P6cSs";
var _b = "Modal-module__title--spt8V";
var _c = "Modal-module__titleMarginContainer--solZQ";
var _d = "Modal-module__widthAuto--Sskbh";
export { _1 as "actionFooter", _2 as "alignEnd", _3 as "animatedBackground", _4 as "closeContainer", _5 as "fullscreen", _6 as "modal", _7 as "noPadding", _8 as "primary", _9 as "small", _a as "subtitle", _b as "title", _c as "titleMarginContainer", _d as "widthAuto" }
